import React, { useCallback } from 'react'
import { I18n } from '@front/volcanion/'

import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'
import { Box, Typography, StepLabel, StepContent } from '@mui/material'

import Callbacks from './callbacks'

import Form from './Form'
import Header from './Header'
import Row from './Row'

const ServiceSection = ({ record_id, navigate, enableSubmitAll }) => {

  const filterToForm = useCallback(Callbacks.filterToFormHandler(), [])
  const formToFilter = useCallback(Callbacks.formToFilterHandler(record_id), [record_id])
  const filterToState = useCallback(Callbacks.filterToStateHandler(), [])
  const formToRecord = useCallback(Callbacks.formToRecordHandler(record_id), [record_id])
  const recordToForm = useCallback(Callbacks.recordToFormHandler(), [])
  const getEmptyForm = useCallback(Callbacks.getEmptyFormHandler(), [])
  const onRowClick = useCallback((rowId, row) => navigate(`/schedule/${_.get(row, 'schedule.schedule_id')}`), [navigate])

  return (
    <>
      <StepLabel>
        <Typography variant='h5'>{I18n.t('date.period')}</Typography>
      </StepLabel>
      <StepContent>
        <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
          <SearchFrame
            model_name={'companyserviceschedules'}
            populate={['schedule']}
            allowCreate={false}
            createPlacement={'bottom'}
          >
            <SearchForm
              filterToForm={filterToForm}
              formToFilter={formToFilter}
              filterToState={filterToState}
              submitOnMount
              disableButton
            >
              <FormContent><Form /></FormContent>
            </SearchForm>
            <SearchTable
              formProps={{
                recordToForm,
                formToRecord,
                getEmptyForm,
                disableParentSubmitListener: true,
                submitChangesOnly: false
              }}
              formActionsProps={{
                enableSubmitAll
              }}
              tableProps={{
                onRowClick,
                allowEditMode: true,
                enablePagination: false,
                enableRowActions: true,
                enableGlobalActions: true,
                addRowLabel: I18n.t('schedule.add.short'),
                enableGlobalActionsPlacement: 'bottom'
              }}
            >
              <TableHeader><Header /></TableHeader>
              <TableRow><Row /></TableRow>
            </SearchTable>
          </SearchFrame>
        </Box>
      </StepContent>
    </>
  )
}

export default React.memo(ServiceSection)
